import { NpvrUtil } from "../../AAF/Npvr/NpvrUtil";
import Utils from "../../utils/Utils";
import TvChannelUtil from '../../utils/TvChannelUtil';
import MultipleLangLive from '../../AAF/LanguageLive/MultipleLangLive';
import SetLangsLive from './components/SetLangsLive';
import PlayerAudioSubtitleHelper from '../../AAFPlayer/helpers/PlayerAudioSubtitleHelper';
import * as constant from '../../AAFPlayer/constants';
import logger from 'src/utils/logger/logger';

export const hasEventOptions = (event, user )=> {
    const {
        session_userhash = null
    } = user ;
    return (session_userhash && (hasEventRecordButton({...event}) || hasEventReminderButton({...event})));
}

export const hasEventRecordButton = event => {
    return NpvrUtil.eventIsRecordable({...event});
}


export const hasEventReminderButton = event => {
    const {
        date_begin
    } = event || {};
    const _isCurrentEvent = isCurrentEvent({...event});
    const _isPastEvent= isPastEvent({...event});
    const minutesBeforeToReminder = 10;
    const reminderTime = (date_begin - (minutesBeforeToReminder * 60));
    const canNotReminderEvent = reminderTime < Utils.nowAsTimestampSeconds();
    return ( !_isCurrentEvent && !_isPastEvent && !canNotReminderEvent);
}

export const isCurrentEvent= ( event ={} ) => {
    return Utils.isDateBetween(event.date_begin, event.date_end)
}

export const isPastEvent = ( event ={} ) => {
    return Utils.isDateBetween(event.date_end, Utils.nowAsTimestampSeconds())
}


export const isMAEnabled = (event = {}, streamtype = '', streamContentType = '') =>{
    let result =  false;
    const currentGroupId = TvChannelUtil.getLastChannel();
    const {group_id = ''} = event;
    if(currentGroupId !== group_id && (streamContentType!==constant.AAF_CONTENT_IS_NPVR)) return false;
    if(!MultipleLangLive.isEnabled()) return false;
    const audiosSubs = PlayerAudioSubtitleHelper.getAndroidAudioSubtitleLive(SetLangsLive.get());

    // [EOER] - Se remueve validación de audiosSub de Android para habilitar experiencia MA en OTT
    // Al menos existe un audio o un subtitulo
    // if(audiosSubs && audiosSubs.audio && audiosSubs.subtitles && Array.isArray(audiosSubs.audio) && Array.isArray(audiosSubs.subtitles) && (audiosSubs.audio.length > 0 || audiosSubs.subtitles.length > 0)){
        switch(streamContentType){
            case constant.AAF_CONTENT_IS_TV:
            case constant.AAF_CONTENT_IS_STARTOVER:
            case constant.AAF_CONTENT_IS_CATCHUP:
            case constant.AAF_CONTENT_IS_NPVR:
                // Verificando que el streamContentType este en metadata
                result = streamtype && MultipleLangLive.streamIsEnabled(streamtype) && MultipleLangLive.isGroupIdEnabled(group_id, streamtype);
                break;
            default:
                break;
        }
    // }
    logger.debug("[EOER - isMAEnabled: currentGroupId]", currentGroupId);
    logger.debug("[EOER - isMAEnabled: group_id]", group_id);
    logger.debug("[EOER - isMAEnabled: audioSubs]", audiosSubs);
    logger.debug("[EOER - isMAEnabled: MultipleLangLive.isEnabled()]", MultipleLangLive.isEnabled());
    logger.debug("[EOER - isMAEnabled: streamtype]", streamtype);
    logger.debug("[EOER - isMAEnabled: MultipleLangLive.streamIsEnabled(streamtype)]", MultipleLangLive.streamIsEnabled(streamtype));
    logger.debug("[EOER - isMAEnabled: MultipleLangLive.isGroupIdEnabled(group_id, streamtype)]", MultipleLangLive.isGroupIdEnabled(group_id, streamtype));
    logger.debug("[EOER - isMAEnabled: result]", result);
    return result;
}



// WEBPACK FOOTER //
// ./src/components/EventOptions/EventOptionsUtils.js